import { getSessid } from "../../../utils";
import { debouncePromised } from "../debouncePromised";

export class Session {
    constructor() {
        /**
         * Обновляет текщую сессию
         * @returns 
         */
        this.updateSessid = debouncePromised(async () => {
            this.sessid = (await getSessid()).data;
        })
    }

    get sessid() {
        return window.config.bitrix_sessid;
    }

    set sessid(val) {
        window.config.bitrix_sessid = val;
    }
}

export const session = new Session();
